import clsx from 'clsx';
import s from './button.module.scss';
import type { ButtonProps } from './button.types';

export const Button = ({
  disabled = false,
  onClick,
  theme,
  size,
  name,
  leftIcon,
  rightIcon,
  className,
}: ButtonProps) => {

  return (
    <div
      className={clsx(className, {
        [s.baseButton]: true,
        [s[theme]]: theme,
        [s[size]]: size,
        [s.disabled]: disabled,
      })}
      onClick={onClick}
    >
      <span className={s['icon-container']}>{leftIcon || null}</span>
      {name}
      <span className={s['icon-container']}>{rightIcon || null}</span>
    </div>
  );
};